import axios from '@/assets/js/axios.js'
import { USER_SERVICE_API } from './apis'
// 修改密码
export function updatePwd (params) {
  return axios({
    url: USER_SERVICE_API.USER_UPDATE_PASSWORD,
    method: 'post',
    data: params
  })
}
// 用户列表
export function userList (params) {
  return axios({
    url: USER_SERVICE_API.USER_LIST,
    method: 'post',
    data: params
  })
}
// 添加用户
export function addUser (params) {
  return axios({
    url: USER_SERVICE_API.USER,
    method: 'post',
    data: params
  })
}
// 修改用户信息
export function editUser (params) {
  return axios({
    url: USER_SERVICE_API.USER,
    method: 'put',
    data: params
  })
}
// 删除用户信息
export function deleteUser (params) {
  return axios({
    url: USER_SERVICE_API.USER + '/' + params,
    method: 'DELETE'
  })
}
// 分配用户角色
export function bindRole (params) {
  return axios({
    url: USER_SERVICE_API.USER_BING_ROLE,
    method: 'post',
    data: params
  })
}
// 获取用户信息
export function userInfo (params) {
  return axios({
    url: USER_SERVICE_API.USER_INFO,
    method: 'get'
  })
}
// 启用禁用
export function userStatus (params) {
  return axios({
    url: USER_SERVICE_API.USER_STATUS + '/' + params,
    method: 'get'
  })
}
// 重置账号密码
export function userReset (params) {
  return axios({
    url: USER_SERVICE_API.USER_RESET + '/' + params,
    method: 'get'
  })
}
// 根据用户id查询对应角色
export function listByUserId (params) {
  return axios({
    url: USER_SERVICE_API.USER_LIST_BY_USER_ID,
    method: 'get',
    params: params
  })
}
